import React, { Component } from 'react'
import { Card, Popconfirm, Icon, message } from 'antd'
import { observer } from "mobx-react"
import Modal from 'react-modal'
import { finalizeAbandoned as finalizeApi } from '../../../api-calls/customWagers'
import { finalizeAbandonedBet as finalizeContract } from '../../../contract/CustomWagersController'
// import { submitVote as submitVoteContract } from '../../../contract/CustomWagersController'
// import { submitVote as submitVoteApi } from '../../../api-calls/customWagers'

@observer(["AuthStore", "UserStore", "TeamStore"])
export default class FinalizeAbandoned extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
        this.finalize = this.finalize.bind(this);

    }


    finalize() {
        const { AuthStore, UserStore } = this.props;
        let bytes32Id = this.props.wager.bytes32Id;
        let wagerId = this.props.wager._id;
        let userId = UserStore.user._id;
        let authToken = AuthStore.userAuth.auth.accessToken;
        let chosenWinner = this.state.chosenWinner;
        let winnerVote;
        let self = this;

        // console.log("Submitting vote for bet " + this.props.wager.bytes32Id);
        // console.log("choice " + chosenWinner);

        // if (chosenWinner == null) {
        //     message.info("You must select a winner!");
        // } else {
        finalizeContract(bytes32Id).then(
            function (result) {
                if (String(result).includes('User denied transaction signature')) {
                    message.warning("Metamask transaction denied! Bet not finalized.");
                } else {
                    return finalizeApi(
                        authToken,
                        wagerId,
                        bytes32Id
                    ).then(function () {
                        return UserStore.updateUser(authToken);
                    });
                }
            });
    }






render() {

    return (
        <div>

            <button className="custom-btn-primary" onClick={this.finalize}>Finalize Bet</button>
        </div>
    )
}
}



// WEBPACK FOOTER //
// ./src/components/layoutComponents/customWagerStages/FinalizeAbandoned.js